import { Button, Paper, Typography } from '@material-ui/core';
import { WithStyles } from 'decorators/withStyles';
import React, { Fragment, PureComponent } from 'react';

interface IState {}

interface IProps {
  title: string;
  subtitle: string;
  buttonTitle?: string;
  onClick?: () => void;
  classes?: any;
}

@WithStyles(() => ({
  containerPaper: {
    padding: '110px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column'
  },
  tab: {
    marginTop: '24px'
  },
  title: {
    color: '#596375',
    textAlign: 'center'
  },
  subtitle: {
    color: '#8C9198',
    textAlign: 'center',
    marginTop: '20px'
  },
  button: {
    background: '#009358',
    color: 'white',
    marginTop: '20px'
  }
}))
export default class EmptyState extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, onClick } = this.props;

    return (
      <Fragment>
        <Paper elevation={0}>
          <div className={classes.containerPaper}>
            <Typography className={classes.title} variant="h3">
              {this.props.title}
            </Typography>
            <Typography className={classes.subtitle} variant="subtitle1">
              {this.props.subtitle}
            </Typography>
            <Button color="inherit" onClick={onClick} className={classes.button}>
              {this.props.buttonTitle}
            </Button>
          </div>
        </Paper>
      </Fragment>
    );
  }
}
